import React, { useEffect, useState } from "react";

import "../../../pages/navbar.css";
import "../../styles.css";
import { ReactComponent as Shieldlowrisk } from "../../../assets/TaxShieldReportsIcons/successIcon.svg";
import { ReactComponent as QuestionIcon } from "../../../assets/TaxShieldReportsIcons/question-circle.svg";
import {
  Container,
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Select,
  MenuItem,
  Divider,
  TableCell,
  TableRow,
  TableBody,
  TableHead,
  TableContainer,
  TablePagination,
  Button, Alert,
} from "@mui/material";
import { TaskRiskReport } from "./type";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import UnknownRiskIcon from "../../../assets/TaxShieldReportsIcons/UnknownRiskIcon.svg";
import { clientConfig } from "../../../awsClientConfig";
import PersonIcon from "@mui/icons-material/Person";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import { formatCurrency } from "../../../functions/misc";
import { Table } from "react-bootstrap";
import { TaxRiskReportItem } from "../../DashBoards/types";
import "./reportStyles.css";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { paths } from "../../../paths";
import useEnrollmentStore, { ProtectionPlanName } from "../../../store/EnrollmentStore";
import { AlertTitle } from "@mui/lab";

type Props = {
  clientName: string;
}

const PlaceholderReport = ({clientName}: Props) => {
  const client = new clientConfig();
  const [allTaxShieldReports, setAllTaxShieldReports] = useState<
    TaxRiskReportItem[]
  >([]);
  const [currentTaxSheildReportId, setCurrentTaxShieldReportId] =
    useState<string>("");
  const [taxShieldReport, setTaxShieldReport] = useState<TaskRiskReport>();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLegacy, setIsLegacy] = useState(false);
  const [singleReportLoading, setSingleReportLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  const [reportDate, setReportDate] = useState({
    Date: "",
    index: 0,
  });
  const [noticePage, setNoticePage] = useState(0);
  const [noticeRowsPerPage, setNoticeRowsPerPage] = useState(3);
  const [taxLiabilityPage, setTaxLiabilityPage] = useState(0);
  const [taxLiabilityRowsPerPage, setTaxLiabilityRowsPerPage] = useState(3);
  const { protectionPlanEnrollment } = useEnrollmentStore();

  const handleNoticesChangePage = (event: unknown, newPage: number) => {
    setNoticePage(newPage);
  };

  const handleNoticesChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setNoticeRowsPerPage(parseInt(event.target.value, 10));
    setNoticePage(0);
  };

  const handleTaxLiablityChangePage = (event: unknown, newPage: number) => {
    setTaxLiabilityPage(newPage);
  };

  const handleTaxLiablityChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setTaxLiabilityRowsPerPage(parseInt(event.target.value, 10));
    setTaxLiabilityPage(0);
  };
  const riskIndicators = taxShieldReport?.RiskIndicators;
  const recentActivity = taxShieldReport?.RecentActivity;
  const noticeUpdates = taxShieldReport?.NoticesUpdates || [];
  const taxLiabilitiesByYear = taxShieldReport?.TaxLiabilitiesByYear;
  const TotalLiability = taxShieldReport?.TotalLiability;

  const auditReviewIcon = () =>
    riskIndicators?.AuditReview ? (
      <QuestionIcon width={40} height={40} className="icon-class" />
    ) : (
      <QuestionIcon width={40} height={40} className="icon-class" />
    );
  const collectionActivityIcon = () =>
    riskIndicators?.CollectionActivity ? (
      <QuestionIcon width={40} height={40} className="icon-class" />
    ) : (
      <QuestionIcon width={40} height={40} className="icon-class" />
    );
  const noticeUpdateIcon = () =>
    riskIndicators?.NoticeUpdate ? (
      <QuestionIcon width={40} height={40} className="icon-class" />
    ) : (
      <QuestionIcon width={40} height={40} className="icon-class" />
    );
  const federalComplianceIcon = () =>
    riskIndicators?.FederalCompliance ? (
      <QuestionIcon width={40} height={40} className="icon-class" />
    ) : (
      <QuestionIcon width={40} height={40} className="icon-class" />
    );


  const riskIndicatorsArray = [
    {
      label: "NOTICES & UPDATES",
      icon: noticeUpdateIcon(),
    },
    {
      label: "FEDERAL COMPLIANCE",
      icon: federalComplianceIcon(),
    },
    {
      label: "COLLECTION ACTIVITY",
      icon: collectionActivityIcon(),
    },
    {
      label: "AUDIT REVIEW",
      icon: auditReviewIcon(),
    }
  ];


  return (
    <>
        <Container sx={{ marginTop: "10px" }} id="report_container">
          <Grid
            container
            spacing={2}
            justifyContent={"space-between"}
            marginBottom={"10px"}
            paddingTop={"14px"}
            marginTop={0}
          >
            <Grid item sm={12} md={12} lg={6}>
              <Card sx={{ height: "100%" }}>
                <CardContent
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                    justifyContent: "start",
                  }}
                >
                  {isLoading ? (
                    <Skeleton width={"100%"} className="mt-3" />
                  ) : (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "32px 24px 16px 24px",
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <div style={{ padding: "0px 16px 0px 0px" }}>
                          <PersonIcon />
                        </div>
                          <Typography variant="h6" sx={{ fontWeight: "500", fontSize: "18px" }}>
                            {clientName}
                          </Typography>

                      </div>
                    </Box>
                  )}
                  {/*<Alert severity="info">This is an info Alert.</Alert>*/}
                  <Alert className='mt-4 mb-5' severity="info">
                    <AlertTitle>Your Risk Report is currently being generated. Generally, this takes 2-3 weeks to process.</AlertTitle>
                    Although your Risk Report isn’t viewable quite yet, we welcome you to review your account details and other resources on the Portal.
                    We’ll email you when your Risk Report is ready and viewable within your dashboard.
                  </Alert>
                    <img
                      src={UnknownRiskIcon}
                      className="w-75 d-block mt-5 mx-auto"
                      alt="report"
                    />

                  <Box className='mt-3'
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      paddingLeft: "40px",
                      paddingRight: "40px",
                    }}
                  >
                    <Typography
                      variant="h3"
                      className='mt-4'
                      padding={"5px"}
                      fontWeight={700}
                      fontSize={36}
                    >
                      UNKNOWN RISK
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>

            <Grid item sm={12} md={12} lg={6}>
              <Grid>
                <Card className="border-0" sx={{ marginBottom: "30px" }}>
                  <CardContent>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        color: "#667085",
                      }}
                    >
                      <div style={{ marginLeft: "100%" }}>
                        {isLoading ? (
                          <Skeleton />
                        ) : (
                          <PrintOutlinedIcon />
                        )}
                      </div>
                      {isLoading && singleReportLoading ? (
                        <Skeleton width={400} />
                      ) : (
                        <Select
                          disabled
                          sx={{
                            width: "70%",
                            marginTop: "10px",
                            boxShadow: "0px 1px 2px 0px #00000014",
                            border: "1px solid #1D89D2",
                            backgroundColor: "#F0F7FC",
                            padding: "20px 12px",
                            textAlign: "center",
                            ".MuiSelect-select": {
                              display: "flex",
                              justifyContent: "center",
                            },
                          }}
                          value={reportDate}
                          renderValue={(selected) =>
                            "BUILDING REPORT"
                          }
                        >
                          {allTaxShieldReports?.map(
                            (report: any, index: any) => {
                              return (
                                <MenuItem
                                  key={report.Id}
                                  value={[report.Id, report.ReportDate, index]}
                                >
                                  BUILDING REPORT
                                </MenuItem>
                              );
                            }
                          )}
                        </Select>
                      )}
                      <Typography variant="body1" sx={{ padding: "1.5rem" }}>
                        Total Estimated Federal Liability *
                      </Typography>
                      {isLoading ? (
                        <Skeleton width={400} count={3} />
                      ) : (
                        <Typography
                          sx={{
                            fontSize: "60px",
                            lineHeight: "68px",
                            fontWeight: 800,
                            color: "#4C5360",
                          }}
                        >
                          $ --
                        </Typography>
                      )}
                      <Typography variant="body1" sx={{ padding: "1.5rem" }}>
                        Balances are subject to daily penalties and interest.
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
                <Card className="border-0">
                  <CardContent
                    sx={{
                      padding: "30px, 24px, 24px, 24px",
                      gap: "16px",
                      color: "#667085",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        variant="h5"
                        sx={{
                          fontWeight: "600",
                          fontSize: "18px",
                          marginTop: "8px",
                          color: "#000",
                        }}
                      >
                        RECENT ACTIVITY
                      </Typography>
                      <Box
                        sx={{
                          width: "100%",
                          display: "flex",
                          alignContent: "center",
                          justifyContent: "space-between",
                          marginTop: "10px",
                          marginBottom: "10px",
                        }}
                      >
                        {isLoading ? (
                          <Skeleton width={450} />
                        ) : (
                          <>
                            <Typography
                              variant="body2"
                              className="recent-activity-title"
                            >
                              Type
                            </Typography>
                            <Typography
                              variant="body2"
                              className="recent-activity-description"
                            >
                              Payment
                            </Typography>
                          </>
                        )}
                      </Box>
                      <Divider
                        variant="fullWidth"
                        sx={{
                          borderColor: "rgba(0, 0, 0, 0.12)",
                          width: "100%",
                          marginY: 1,
                        }}
                      />
                      <Box
                        sx={{
                          width: "100%",
                          display: "flex",
                          alignContent: "center",
                          justifyContent: "space-between",
                          marginTop: "10px",
                          marginBottom: "10px",
                        }}
                      >
                        {isLoading ? (
                          <Skeleton width={450} />
                        ) : (
                          <>
                            <Typography
                              variant="body2"
                              className="recent-activity-title"
                            >
                              Amount
                            </Typography>
                            <Typography
                              variant="body2"
                              className="recent-activity-description"
                            >
                              $ --
                            </Typography>
                          </>
                        )}
                      </Box>
                      <Divider
                        variant="fullWidth"
                        sx={{
                          borderColor: "rgba(0, 0, 0, 0.12)",
                          width: "100%",
                          marginY: 1,
                        }}
                      />
                      <Box
                        sx={{
                          width: "100%",
                          display: "flex",
                          alignContent: "center",
                          justifyContent: "space-between",
                          marginTop: "10px",
                          marginBottom: "10px",
                        }}
                      >
                        {isLoading ? (
                          <Skeleton width={450} />
                        ) : (
                          <>
                            <Typography
                              variant="body2"
                              className="recent-activity-title"
                            >
                              Tax Year
                            </Typography>
                            <Typography
                              variant="body2"
                              className="recent-activity-description"
                            >
                              --
                            </Typography>
                          </>
                        )}
                      </Box>
                      <Divider
                        variant="fullWidth"
                        sx={{
                          borderColor: "rgba(0, 0, 0, 0.12)",
                          width: "100%",
                          marginY: 1,
                        }}
                      />
                      <Box
                        sx={{
                          width: "100%",
                          display: "flex",
                          alignContent: "center",
                          justifyContent: "space-between",
                          marginTop: "10px",
                          marginBottom: "10px",
                        }}
                      >
                        {isLoading ? (
                          <Skeleton width={450} />
                        ) : (
                          <>
                            <Typography className="recent-activity-title">
                              Date Received
                            </Typography>
                            <Typography
                              variant="body2"
                              className="recent-activity-description"
                            >
                             --
                            </Typography>
                          </>
                        )}
                      </Box>
                      <Divider
                        variant="fullWidth"
                        sx={{
                          borderColor: "rgba(0, 0, 0, 0.12)",
                          width: "100%",
                        }}
                      />
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          width: "100%",
                          alignItems: "center",
                          padding: "0.5rem",
                        }}
                      >
                        <Box>
                          <Typography variant="body2" textAlign={"center"}>
                            It may take up to 2 business days after the funds have been drafted for your payment to post to your account
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={2}
            justifyContent={"space-between"}
            marginBottom={"10px"}
          >
            {riskIndicatorsArray.length &&
              riskIndicatorsArray.map((item, index) => (
                <Grid key={index} item xs={12} md={6} sm={12} lg={3}>
                  <Card
                    sx={{
                      paddingBottom: "0px",
                      height: "100%",
                      display: "flex",
                    }}
                  >
                    <CardContent
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        padding: "24px 20px",
                        paddingBottom: "24px !important",
                      }}
                    >
                      {isLoading ? (
                        <Skeleton width={225} />
                      ) : (
                        <>
                          <div style={{ height: "40px", width: "40px" }}>
                            {item.icon}
                          </div>
                          <Typography
                            sx={{
                              marginLeft: "10px",
                              fontWeight: 600,
                              color: "#212636",
                              fontSize: "18px",
                            }}
                          >
                            {item.label}
                          </Typography>
                        </>
                      )}
                    </CardContent>
                  </Card>
                </Grid>
              ))}
          </Grid>

          <Grid
            container
            spacing={2}
            justifyContent={"space-between"}
            marginBottom={"10px"}
          >
            <Grid item xs={12} sm={12} md={12} lg={6}>
              <Card sx={{ height: "100%" }}>
                <CardContent
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "stretch",
                    alignItems: "center",
                    paddingBottom: 0,
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "600",
                      padding: "10px",
                      fontSize: "18px",
                      textAlign: "center",
                      color: "rgba(33, 38, 54, 1)",
                    }}
                  >
                    NOTICES & UPDATES
                  </Typography>
                  <TableContainer
                    sx={{ marginTop: "10px", marginBottom: "10px" }}
                  >
                    <Table aria-label="sticky table">
                      <TableHead
                        sx={{
                          ".MuiTableCell-root": {
                            backgroundColor: "#EDF7FF",
                            color: "#667085",
                            padding: "1rem",
                          },
                        }}
                      >
                        <TableRow>
                          <TableCell
                            align="left"
                            className="table-cell"
                            colSpan={2}
                          >
                            TAX YEAR
                          </TableCell>
                          <TableCell align="left" colSpan={3}>
                            NOTICE TYPE
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                          <TableRow>
                          </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={6}>
              <Card sx={{ height: "100%" }}>
                <CardContent
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "stretch",
                    alignItems: "center",
                    paddingBottom: 0,
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "600",
                      padding: "10px",
                      fontSize: "18px",
                      textAlign: "center",
                      color: "rgba(33, 38, 54, 1)",
                    }}
                  >
                    FEDERAL TAX LIABILITY BY YEAR
                  </Typography>
                  <TableContainer
                    sx={{ marginTop: "10px", marginBottom: "10px" }}
                  >
                    <Table aria-label="sticky table">
                      <TableHead
                        sx={{
                          ".MuiTableCell-root": {
                            backgroundColor: "#EDF7FF",
                            color: "#667085",
                            padding: "1rem",
                          },
                        }}
                      >
                        <TableRow>
                          <TableCell align="left" colSpan={2}>
                            TAX YEAR
                          </TableCell>
                          <TableCell align="left" colSpan={2}>
                            CURRENT BALANCE
                          </TableCell>
                          <TableCell align="left" colSpan={2}>
                            FILING STATUS
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          <Grid>
            <TermSentence style={{ zIndex: 10, fontSize: 12 }} className="media-term-text">
              Copyright © Optima Tax Relief, LLC | All Rights Reserved
              <Dot>•</Dot>
              <ForgotPasswordLink
                href="https://optimataxrelief.com/about-us/terms-of-site/"
                target="_blank"
                rel="noreferrer"
                className="media-term-text"
              >
                Terms & Conditions{" "}
              </ForgotPasswordLink>
              <Dot>•</Dot>
              <ForgotPasswordLink
                href="https://optimataxrelief.com/about-us/privacy/"
                target="_blank"
                rel="noreferrer"
                className="media-term-text"
              >
                Privacy Policy
              </ForgotPasswordLink>
            </TermSentence>
          </Grid>
        </Container>
    </>
  );
};

export default PlaceholderReport;

const TermSentence = styled.div`
  align-items: center;
  text-align: center;
  margin: 2rem 1rem 2rem;
  color: #8E8E93;
`;

const ForgotPasswordLink = styled.a`
  text-decoration: none;
  cursor: pointer;
  margin-left: 3px;
  color: #1D89D2;
`;

const Dot = styled.span`
  margin-left: 3px;
`;
